'use client'

import React from 'react'
import type { Locale } from '@/i18n'
import { cn } from '@/utilities/ui'
import { useApplicationModalStore } from '@/stores/applicationModalStore'
import { trackVacancyApplyClick } from '@/utilities/analytics'

interface VacancyCTAProps {
  locale: Locale
  positionSlug: string
  vacancyTitle?: string
  className?: string
}

export function VacancyCTA({ locale, positionSlug, vacancyTitle, className }: VacancyCTAProps) {
  const { openModal } = useApplicationModalStore()

  const t = {
    uk: { join: 'Приєднатися' },
    en: { join: 'Apply Now' },
  }[locale]

  const handleClick = () => {
    // Track vacancy apply click
    trackVacancyApplyClick(vacancyTitle || positionSlug, positionSlug)
    openModal('civil', positionSlug)
  }

  return (
    <>
      {/* Mobile & Desktop Sticky CTA with position slug */}
      <div className="mt-12 pt-8 border-t border-border md:relative mb-20 md:mb-0">
        <div
          className={cn(
            'fixed bottom-0 left-0 right-0 md:static z-[100]',
            'bg-background p-2 md:p-0 md:bg-transparent',
            className,
          )}
        >
          <button
            onClick={handleClick}
            className="rounded-full md:rounded-lg ml-auto inline-flex items-center justify-center px-6 py-3 bg-primary text-white hover:bg-primary/90 transition-colors text-lg font-medium w-full md:w-auto"
          >
            {t.join}
          </button>
        </div>
      </div>
    </>
  )
}
